module.exports = __webpack_public_path__ + "static/media/bandeiras.29027bff.png";